// @ts-nocheck
import {
    AxiosError,
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse,
} from "axios";
import axios from 'axios'

import KeyCloak from "../../Auth/Keycloak";

// Lo que hace este builder es crear la instancia y generar un interceptador, que lo que hace es que cuando la request falla porque el token es viejo, se lo actualiza a la instancia para seguir haciendo requests

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = KeyCloak.getToken()
    config.headers["Authorization"] = `Bearer ${token}`;

    return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
    return response;
};

const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
    if (error.response) {
        // Access Token was expired
        console.error(error.response.data)
        if (
            error.response.status === 401 &&
            (error.response.data === "Expired JWT Token" || error.response.data === "Invalid JWT Token")
        ) {
            try {
                await KeyCloak.updateToken();

                const token = KeyCloak.getToken()
                error.config.headers["Authorization"] = `Bearer ${token}`;


                return axios.request(error.config);
            } catch (_error) {
                return Promise.reject(_error);
            }
        }
    }
    return Promise.reject(error);
};

export const setupInterceptorsTo = (
    axiosInstance: AxiosInstance
): AxiosInstance => {
    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    axiosInstance.interceptors.response.use(onResponse, onResponseError);
    return axiosInstance;
};


